import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './App.css'
import {NuqsAdapter} from "nuqs/adapters/react";
import I18nApp from "@/I18nApp.tsx";
import {i18n} from "@lingui/core";

i18n.load('en', {});
i18n.activate('en');
// import { registerSW } from 'virtual:pwa-register'
//
// const updateSW = registerSW({
//     onNeedRefresh() {},
//     onOfflineReady() {},
// })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <NuqsAdapter>
         <I18nApp/>
        </NuqsAdapter>
  </StrictMode>,
)

